import React from 'react';
import parse from 'html-react-parser';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const CrewItem = ({ crewItemTitle, crewItemSubtitle, color }) => {
    return (
        <ScrollAnimation
            animateIn="fadeInUp"
            offset={50}
            delay={100}
            animateOnce={true}
            duration={1}
            className="crew__list-item"
        >
            <div className="crew__list-info">
                <div className={`crew__list-title ${color ? 'crew__list-title--purple' : ''}`}>
                    {crewItemTitle}
                </div>
                <div className="crew__list-subtitle">{parse(crewItemSubtitle)}</div>
            </div>
        </ScrollAnimation>
    );
};

export default CrewItem;
